import { render, staticRenderFns } from "./StockPlaceMold.vue?vue&type=template&id=2a8db7be&"
import script from "./StockPlaceMold.vue?vue&type=script&lang=js&"
export * from "./StockPlaceMold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports